import type { JsonScimToken } from "authentication/js/api/scim-tokens.api";
import { createScimToken, getScimTokens } from "authentication/js/api/scim-tokens.api";
import { createLoadingPromise } from "core/store/store-utils";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

const MAX_ACTIVE_SCIM_TOKENS = 2;

export const useScimStore = defineStore("feature/authentication/scim", () => {
  const tokens = ref<Array<JsonScimToken>>([]);

  async function retrieveScimTokens() {
    tokens.value = await getScimTokens();
  }

  const scimTokens = computed(() => tokens.value);
  const canCreateNewToken = computed(() =>
    tokens.value
      .filter(token => token.status === "ACTIVE")
      .length < MAX_ACTIVE_SCIM_TOKENS,
  );

  const loadingPromise = createLoadingPromise(retrieveScimTokens);

  const generateScimToken = async () => {
    const newToken = await createScimToken();
    await retrieveScimTokens();
    return newToken;
  };

  return {
    tokens,
    scimTokens,
    generateScimToken,
    canCreateNewToken,
    isReady: loadingPromise,
  };
});
